module.exports = __webpack_public_path__ + "assets/img/audience2.2e2fd947.svg";